import styled, { css } from "styled-components";
import { colors } from "constants/colors";
import icOkSelected from "assets/images/ic_ok_selected_outlined_orange_m.png";
import icGlobal from "assets/images/micro/ic_global_white_s.svg";
import icDropdown from "assets/images/ic_dropdown_normal_outlined_white_m.svg";

export const PolicyContainer = styled.section`
  margin: 0 auto;
  padding: 48px 32px 100px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.04em;
  color: ${colors.subBody3};
  @media (min-width: 1024px) {
    max-width: 1040px;
    padding-left: 40px;
    padding-right: 40px;
  }
  strong {
    font-weight: 500;
  }
  p + p {
    margin-top: 16px;
  }
`;

export const PolicyContainerApp = styled(PolicyContainer)`
  padding-top: 86px;
`;

export const PolicyTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 40px;
  color: ${colors.black};
`;

export const PolicySectionTitle = styled.h3`
  margin: 64px 0 16px;
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  color: ${colors.black};
  & + h4 {
    margin-top: 0;
  }
`;

export const PolicyArticleTitle = styled.h4`
  margin: 32px 0 16px;
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  color: ${colors.black};
`;

export const PolicyVersion = styled.p`
  margin-bottom: 32px;
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  color: ${colors.black};
`;

export const PolicyText = styled.p``;

export const CaptionHide = styled.caption`
  overflow: hidden;
  width: 0;
  height: 0;
  visibility: hidden;
  font-size: 0;
  line-height: 0;
`;

export const PolicyMenu = styled.div`
  padding-top: 36px;
  p,
  li {
    font-size: 12px;
    line-height: 22px;
  }
  ${PolicyArticleTitle} {
    margin-top: 0;
  }
`;

export const PolicyHyphenList = styled.ul`
  margin: 24px 0;
  li {
    padding-left: 10px;
    text-indent: -10px;
    + li {
      margin-top: 8px;
    }
    &:before {
      content: "-";
      float: left;
      margin-right: 10px;
    }
  }
`;

export const PolicyHyphenListBox = styled.div`
  margin-top: 24px;
  ${PolicyHyphenList} {
    margin-top: 0;
  }
`;
export const PolicyTable = styled.table`
  margin-top: 24px;
  color: ${colors.subBody3};
  caption {
    padding-bottom: 10px;
    text-align: left;
  }
  th,
  td {
    font-size: 12px;
    line-height: 22px;
    text-align: center;
    border: 1px solid #e6e6e6;
    word-break: break-word;
  }
  th {
    padding: 9px 4px;
    background-color: #eee;
    font-weight: 500;
  }
  td {
    padding: 20px 4px;
  }
  tbody th {
    font-weight: 400;
  }
  .cell_left {
    padding-left: 8px;
    padding-right: 8px;
    text-align: left;
  }
  ${PolicyHyphenList} {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const PolicyList = styled.ul`
  margin-top: 16px;
  & > li {
    padding-left: 14px;
    text-indent: -14px;
    & + li {
      margin-top: 16px;
    }
  }
  p,
  :not(${PolicyHyphenList}) > li {
    text-indent: 0;
  }
  p + ${PolicyTable} {
    margin-top: 5px;
    margin-bottom: 16px;
  }

  & + p {
    padding-top: 24px;
  }
  ${PolicyTable} {
    width: calc(100% + 15px);
    margin-top: 16px;
    margin-left: -15px;
    td,
    th {
      text-indent: 0;
    }
  }
  ${PolicyHyphenList} {
    margin-top: 8px;
  }
`;

export const PolicyNumberList = styled.ol`
  margin-top: 16px;
  counter-reset: policyNum;
  & > li {
    position: relative;
    padding-left: 22px;
    counter-increment: policyNum;
    & + li {
      margin-top: 16px;
    }
    &:before {
      content: counter(policyNum) ".";
      position: absolute;
      left: 0;
    }
  }
  ${PolicyHyphenList} {
    margin-top: 8px;
  }
`;

export const Icon = styled.span`
  display: inline-block;
  background-color: ${colors.black};
  mask-repeat: no-repeat;
  vertical-align: middle;
`;

export const StyledIconGlobal = styled(Icon)`
  width: 30px;
  height: 30px;
  margin-right: 4px;
  mask-image: url(${icGlobal});
`;

export const StyledIconDropdown = styled(Icon)`
  width: 54px;
  height: 54px;
  margin-left: -4px;
  transition: transform 0.5s;
  mask-image: url(${icDropdown});
`;

export const BtnLanguage = styled.button`
  font-size: 20px;
  font-weight: 500;
  color: ${colors.black};
  [class*="icon"] {
    font-size: 0;
    text-indent: 100%;
    background-color: ${colors.black};
  }
`;
export const LanguageListBox = styled.div`
  display: block;
  overflow: hidden;
  opacity: 0;
  max-height: 0;
  position: absolute;
  right: 0;
  top: 54px;
  width: 160px;
  border: 0 solid ${colors.lightGray1};
  background-color: ${colors.white};
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  text-align: left;
  ul {
    padding: 8px 0;
  }
  a,
  em {
    display: block;
    padding: 16px;
    font-size: 20px;
    line-height: normal;
  }
  a:hover {
    color: ${colors.mainOrange};
    text-decoration: none;
  }
  em {
    font-weight: 500;
    color: ${colors.mainOrange};
  }
  .selected {
    padding: 13px 16px;
    font-size: 20px;
    em {
      padding: 0;
      &:after {
        content: "selected";
        display: inline-block;
        width: 36px;
        height: 36px;
        margin-top: -2px;
        background: url(${icOkSelected}) no-repeat 0 0 / 100%;
        font-size: 0;
        line-height: 0;
        text-indent: 100%;
        vertical-align: middle;
      }
    }
  }
`;

export const LanguageBox = styled.div<{ isOpen: boolean }>`
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  color: ${colors.black};
  ${({ isOpen }) =>
    isOpen &&
    css`
      ${StyledIconDropdown} {
        transform: rotate(180deg);
      }
      ${LanguageListBox} {
        opacity: 1;
        transition: opacity 0.4s;
        will-change: opacity;
        max-height: none;
        border-width: 1px;
      }
    `}
`;
